/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type FeedbackPriority =
  (typeof FeedbackPriority)[keyof typeof FeedbackPriority];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackPriority = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  URGENT: "URGENT",
} as const;
